import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useExpenseCategories } from "@/hooks/useExpenseCategories";
import { useSuppliers } from "@/hooks/useSuppliers";

export interface ExpenseLinkDraft {
  enabled: boolean;
  title: string;
  categoryId: string;
  supplierId?: string;
  dueDate?: string;
}

const NO_SUPPLIER_VALUE = "__no_supplier__";

interface ExpenseLinkFieldsProps {
  value: ExpenseLinkDraft;
  onChange: (next: ExpenseLinkDraft) => void;
  checkboxLabel: string;
  titleLabel?: string;
}

export function ExpenseLinkFields({
  value,
  onChange,
  checkboxLabel,
  titleLabel = "Título",
}: ExpenseLinkFieldsProps) {
  const { categories } = useExpenseCategories();
  const { suppliers } = useSuppliers();

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Checkbox
          id="expense_link_enabled"
          checked={value.enabled}
          onCheckedChange={(checked) =>
            onChange({ ...value, enabled: checked === true })
          }
        />
        <Label htmlFor="expense_link_enabled">{checkboxLabel}</Label>
      </div>

      {value.enabled && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-2 sm:col-span-2">
            <Label htmlFor="expense_title">{titleLabel} *</Label>
            <Input
              id="expense_title"
              value={value.title}
              onChange={(e) => onChange({ ...value, title: e.target.value })}
              placeholder="Ex: Pagamento fornecedor"
            />
          </div>

          <div className="space-y-2">
            <Label>Categoria *</Label>
            <Select
              value={value.categoryId}
              onValueChange={(v) => onChange({ ...value, categoryId: v })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione" />
              </SelectTrigger>
              <SelectContent>
                {categories.map((c) => (
                  <SelectItem key={c.id} value={c.id}>
                    {c.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Fornecedor</Label>
            <Select
              value={value.supplierId || NO_SUPPLIER_VALUE}
              onValueChange={(v) =>
                onChange({
                  ...value,
                  supplierId: v === NO_SUPPLIER_VALUE ? undefined : v,
                })
              }
            >
              <SelectTrigger>
                <SelectValue placeholder="(opcional)" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={NO_SUPPLIER_VALUE}>(Sem fornecedor)</SelectItem>
                {suppliers.map((s) => (
                  <SelectItem key={s.id} value={s.id}>
                    {s.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2 sm:col-span-2">
            <Label htmlFor="expense_due_date">Vencimento</Label>
            <Input
              id="expense_due_date"
              type="date"
              value={value.dueDate || ""}
              onChange={(e) => onChange({ ...value, dueDate: e.target.value || undefined })}
            />
          </div>
        </div>
      )}
    </div>
  );
}
